import { render, staticRenderFns } from "./coupon-t1.vue?vue&type=template&id=3b785d03&scoped=true&"
import script from "./coupon-t1.vue?vue&type=script&lang=js&"
export * from "./coupon-t1.vue?vue&type=script&lang=js&"
import style0 from "./coupon-t1.vue?vue&type=style&index=0&id=3b785d03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b785d03",
  null
  
)

export default component.exports